import { Button } from 'shared/components/button/Button'
import styled from 'styled-components/macro'

export const ResendButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ResendButtonText = styled.span`
  font-size: 16px;
  letter-spacing: -0.075em;
  color: #000000;
`

export const ResendButton = styled(Button)`
  border: none;
  background: none;
  font-weight: 700;
  text-decoration: underline;
  font-size: 16px;
  letter-spacing: -0.075em;
  color: #c00000;
  cursor: pointer;
  width: auto;
  margin-right: 10px;

  &:disabled {
    opacity: 0.3;
  }
`
